import { motion } from "framer-motion";
import { X } from "lucide-react";
import { ZONES, REGIONS } from "../data/regions";

export default function ExplorePanel({ onSelect, onClose }) {
  let index = 0;

  return (
    <>
      <motion.div
        data-testid="explore-backdrop"
        className="fixed inset-0 z-[64] bg-black/60"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{ duration: 0.5 }}
        onClick={onClose}
      />
      <motion.aside
        data-testid="explore-panel"
        className="fixed top-0 right-0 bottom-0 z-[65] w-[min(430px,94vw)] grain archival-scroll overflow-y-auto"
        style={{
          background: "#14110d",
          borderLeft: "1px solid rgba(197,160,89,0.2)",
          boxShadow: "-40px 0 120px rgba(0,0,0,0.7)",
        }}
        initial={{ x: "100%" }}
        animate={{ x: 0 }}
        exit={{ x: "100%" }}
        transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
      >
        <div className="px-8 py-7 flex items-center justify-between sticky top-0 z-10"
          style={{ background: "linear-gradient(#14110d 75%, transparent)" }}>
          <div>
            <p className="font-nav text-[9px] tracking-[0.45em] uppercase text-[#857565]">The Atlas of</p>
            <h2 className="font-display text-2xl tracking-[0.2em] uppercase text-[#E8DCC4] mt-1">Explore</h2>
          </div>
          <button
            data-testid="explore-close"
            onClick={onClose}
            aria-label="Close explore"
            className="text-[#857565] hover:text-[#C5A059] transition-colors duration-500"
          >
            <X size={18} strokeWidth={1.25} />
          </button>
        </div>

        <div className="px-8 pb-24">
          {ZONES.map((zone) => {
            const zoneRegions = REGIONS.filter((r) => r.zone === zone);
            if (!zoneRegions.length) return null;
            return (
              <div key={zone} className="mt-9" data-testid={`zone-${zone.toLowerCase()}`}>
                <div className="flex items-center gap-4 mb-4">
                  <span className="font-nav text-[9px] tracking-[0.5em] uppercase text-[#C5A059]">
                    {zone}
                  </span>
                  <span className="flex-1 h-px bg-[rgba(197,160,89,0.15)]" />
                </div>
                <ul>
                  {zoneRegions.map((r) => {
                    index += 1;
                    const ready = r.images.length > 0;
                    return (
                      <li key={r.id}>
                        <button
                          data-testid={`explore-item-${r.id}`}
                          onClick={() => ready && onSelect(r.id)}
                          disabled={!ready}
                          className={`group w-full flex items-baseline gap-4 py-[9px] text-left transition-colors duration-500 ${
                            ready ? "hover:pl-2" : "cursor-default opacity-45"
                          }`}
                          style={{ transitionProperty: "padding,color" }}
                        >
                          <span className="font-nav text-[9px] tracking-[0.2em] text-[#6f6252] w-6 shrink-0">
                            {String(index).padStart(2, "0")}
                          </span>
                          <span
                            className={`font-display text-base sm:text-lg tracking-[0.08em] ${
                              ready
                                ? "text-[#D6C5B3] group-hover:text-[#C5A059]"
                                : "text-[#857565]"
                            } transition-colors duration-500`}
                          >
                            {r.name}
                          </span>
                          {!ready && (
                            <span className="font-serif-body italic text-xs text-[#6f6252] ml-auto shrink-0">
                              forthcoming
                            </span>
                          )}
                          {ready && (
                            <span className="ml-auto w-[5px] h-[5px] rounded-full bg-[#C5A059] opacity-60 shrink-0 self-center" />
                          )}
                        </button>
                      </li>
                    );
                  })}
                </ul>
              </div>
            );
          })}
        </div>
      </motion.aside>
    </>
  );
}
